/**
 * Initializes the drawer trigger links.
 *
 * Manually adds the bootstrap toggle option to drawer links to avoid the content editors
 * having to add it onto the link.
 */
export const initDrawerLinks = () => {
	const linkEls = document.querySelectorAll('[href="#drawer"]');
	for (const linkEl of linkEls)
		linkEl.setAttribute('data-bs-toggle', 'offcanvas');
};
